//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: 'ModalSendInformation',
    props: {
        showModal: {
            required: true,
            type: Boolean,
        },
        success: {
            required: true,
            type: Boolean,
        },
        customError: {
            required: false,
            type: Boolean,
        },
        prefix: {
            required: true,
            type: String,
        },
        msgSuccess: {
            default: function () {
                return {
                    subtitle: '',
                };
            },
            required: true,
            type: Object,

        },
        msgFail: {
            required: false,
            type: Object,

        },
    },
    data: function () {
        return {
            messages: {
                success: {
                    subtitle: '',
                    title: 'Dados enviados!',
                },
                fail: {
                    subtitle: 'Verifique os dados fornecidos ou tente recarregar a página.',
                    title: 'Ops, algo deu errado! :(',
                },
            },
        }
    },
    computed: {
        message: {
            get: function () {
                let info = {};

                if (this.success) {
                    info = this.messageSuccess;
                } else {
                    info = this.messageFail;
                }

                return info;
            },
        },
        messageSuccess: {
            get: function () {
                let msgSuccess = {
                    subtitle: this.msgSuccess.subtitle,
                    title: this.messages.success.title,
                }

                return msgSuccess;
            },
        },
        messageFail: {
            get: function () {
                if (this.customError) {
                    let msgFail = {
                        subtitle: this.msgFail.subtitle,
                        title: this.msgFail.title,
                    }

                    return msgFail;
                } else {
                    return this.messages.fail;
                }
            },
        },
    },
    watch: {
        showModal: {
            handler: function (newValue) {
                if (newValue) {
                    $(`#${this.prefix}-modal-send-information`).modal('show');
                }
            },
        },
    },
    mounted () {
        //
    },
};



// WEBPACK FOOTER //
// ./scripts/vue/components/common/ModalSendInformation.vue